
const newModel = () => {
    return {
        thethaoNhomgiaiId: null,
        ten: null,
        thethaoPhamviId: null,
        tenThethaoPhamvi: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        iocId: null,
        iocEnabled: null,
        iocDateUpdated: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoNhomgiaiId: null,
        thethaoPhamviId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoNhomgiaiId: item.thethaoNhomgiaiId,
        ten: item.ten,
        thethaoPhamviId: item.thethaoPhamviId,
        tenThethaoPhamvi: item.tenThethaoPhamvi,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoNhomgiaiId: item.thethaoNhomgiaiId,
        ten: item.ten,
        thethaoPhamviId: item.thethaoPhamviId,
        tenThethaoPhamvi: item.tenThethaoPhamvi,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        thethaoNhomgiaiId: null,
        ten: null,
        thethaoPhamviId: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const errors = () => {
    return {
        thethaoNhomgiaiId: null,
        ten: null,
        thethaoPhamviId: null,
        tenThethaoPhamvi: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const nhomGiaiThiDauTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    fromJson,
    errors,
}


